export default {
    //TODO: update with Environment Variables
    "manualUploadEmail": "super@smart-territory.ro"
}
